"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getStagedDefaultOwnerPropertyValueForSelectedProperty = exports.getStagedDefaultCompanyPropertyValueForSelectedProperty = exports.getStagedDefaultContactPropertyValueForSelectedProperty = exports.getStagedDefaultOwnerPropertyValues = exports.getStagedDefaultCompanyPropertyValues = exports.getStagedDefaultContactPropertyValues = exports.getStagedDefaultOwnerProperties = exports.getStagedDefaultCompanyProperties = exports.getStagedDefaultContactProperties = exports.getOwnerPropertiesFilteredBySearch = exports.getContactPropertiesFilteredBySearch = exports.getCompanyPropertiesFilteredBySearch = exports.getSelectedOwnerPropertyObject = exports.getSelectedContactPropertyObject = exports.getSelectedCompanyPropertyObject = exports.getSelectedProperty = exports.getPropertySearch = exports.getCompanyPropertyDefaultsModalOpen = exports.getOwnerPropertyDefaultsModalOpen = exports.getContactPropertyDefaultsModalOpen = exports.getStylesheetSelectModalOpen = void 0;

var _reselect = require("reselect");

var _UrlPathParams = require("settings-ui-sdk/constants/UrlPathParams");

var _selectors = require("settings-ui-sdk/Properties/selectors");

var _interactions = require("../constants/interactions");

var _routeSelectors = require("./routeSelectors");

var _sorts = require("settings-ui-sdk/utils/sorts");

var getInteractions = function getInteractions(state) {
  return state.modules[_UrlPathParams.WEBSITE][_UrlPathParams.PAGES].interactions;
};

var getInteractionsProperty = function getInteractionsProperty(property) {
  return (0, _reselect.createSelector)([getInteractions], function (interactions) {
    return interactions.get(property);
  });
};

var getStylesheetSelectModalOpen = getInteractionsProperty(_interactions.STYLESHEET_SELECT_MODAL_OPEN);
exports.getStylesheetSelectModalOpen = getStylesheetSelectModalOpen;
var getContactPropertyDefaultsModalOpen = getInteractionsProperty(_interactions.CONTACT_PROPERTY_DEFAULTS_MODAL_OPEN);
exports.getContactPropertyDefaultsModalOpen = getContactPropertyDefaultsModalOpen;
var getOwnerPropertyDefaultsModalOpen = getInteractionsProperty(_interactions.OWNER_PROPERTY_DEFAULTS_MODAL_OPEN);
exports.getOwnerPropertyDefaultsModalOpen = getOwnerPropertyDefaultsModalOpen;
var getCompanyPropertyDefaultsModalOpen = getInteractionsProperty(_interactions.COMPANY_PROPERTY_DEFAULTS_MODAL_OPEN);
exports.getCompanyPropertyDefaultsModalOpen = getCompanyPropertyDefaultsModalOpen;
var getPropertySearch = getInteractionsProperty(_interactions.PROPERTY_SEARCH);
exports.getPropertySearch = getPropertySearch;
var getSelectedProperty = getInteractionsProperty(_interactions.SELECTED_PROPERTY);
exports.getSelectedProperty = getSelectedProperty;
var getSelectedCompanyPropertyObject = (0, _reselect.createSelector)([_selectors.getCompanyProperties, getSelectedProperty], function (companyProperties, selectedProperty) {
  return companyProperties.find(function (prop) {
    return prop.get('name') === selectedProperty;
  });
});
exports.getSelectedCompanyPropertyObject = getSelectedCompanyPropertyObject;
var getSelectedContactPropertyObject = (0, _reselect.createSelector)([_selectors.getContactProperties, getSelectedProperty], function (contactProperties, selectedProperty) {
  return contactProperties.find(function (prop) {
    return prop.get('name') === selectedProperty;
  });
});
exports.getSelectedContactPropertyObject = getSelectedContactPropertyObject;
var getSelectedOwnerPropertyObject = (0, _reselect.createSelector)([_selectors.getOwnerProperties, getSelectedProperty], function (ownerProperties, selectedProperty) {
  return ownerProperties.find(function (prop) {
    return prop.get('name') === selectedProperty;
  });
});
exports.getSelectedOwnerPropertyObject = getSelectedOwnerPropertyObject;
var getCompanyPropertiesFilteredBySearch = (0, _reselect.createSelector)([_selectors.getCompanyProperties, getPropertySearch], function (companyProperties, propertySearch) {
  var propertySearchLowCase = (propertySearch || '').toLowerCase();
  return companyProperties.filter(function (property) {
    return property.get('label').toLowerCase().includes(propertySearchLowCase);
  }).sort((0, _sorts.sortByField)('label'));
});
exports.getCompanyPropertiesFilteredBySearch = getCompanyPropertiesFilteredBySearch;
var getContactPropertiesFilteredBySearch = (0, _reselect.createSelector)([_selectors.getContactProperties, getPropertySearch], function (contactProperties, propertySearch) {
  var propertySearchLowCase = (propertySearch || '').toLowerCase();
  return contactProperties.filter(function (property) {
    return property.get('label').toLowerCase().includes(propertySearchLowCase);
  }).sort((0, _sorts.sortByField)('label'));
});
exports.getContactPropertiesFilteredBySearch = getContactPropertiesFilteredBySearch;
var getOwnerPropertiesFilteredBySearch = (0, _reselect.createSelector)([_selectors.getOwnerProperties, getPropertySearch], function (ownerProperties, propertySearch) {
  var propertySearchLowCase = (propertySearch || '').toLowerCase();
  ownerProperties.filter(function (property) {
    return property.get('label').toLowerCase().includes(propertySearchLowCase);
  }).sort((0, _sorts.sortByField)('label'));
});
exports.getOwnerPropertiesFilteredBySearch = getOwnerPropertiesFilteredBySearch;

var getStagedDefaultContactProperties = function getStagedDefaultContactProperties(state) {
  return state.modules[_UrlPathParams.WEBSITE][_UrlPathParams.PAGES].staging.defaultContactProperties;
};

exports.getStagedDefaultContactProperties = getStagedDefaultContactProperties;

var getStagedDefaultCompanyProperties = function getStagedDefaultCompanyProperties(state) {
  return state.modules[_UrlPathParams.WEBSITE][_UrlPathParams.PAGES].staging.defaultCompanyProperties;
};

exports.getStagedDefaultCompanyProperties = getStagedDefaultCompanyProperties;

var getStagedDefaultOwnerProperties = function getStagedDefaultOwnerProperties(state) {
  return state.modules[_UrlPathParams.WEBSITE][_UrlPathParams.PAGES].staging.defaultOwnerProperties;
};

exports.getStagedDefaultOwnerProperties = getStagedDefaultOwnerProperties;
var getStagedDefaultContactPropertyValues = (0, _reselect.createSelector)([getStagedDefaultContactProperties], function (properties) {
  return properties.get('staged');
});
exports.getStagedDefaultContactPropertyValues = getStagedDefaultContactPropertyValues;
var getStagedDefaultCompanyPropertyValues = (0, _reselect.createSelector)([getStagedDefaultCompanyProperties], function (properties) {
  return properties.get('staged');
});
exports.getStagedDefaultCompanyPropertyValues = getStagedDefaultCompanyPropertyValues;
var getStagedDefaultOwnerPropertyValues = (0, _reselect.createSelector)([getStagedDefaultOwnerProperties], function (properties) {
  return properties.get('staged');
});
exports.getStagedDefaultOwnerPropertyValues = getStagedDefaultOwnerPropertyValues;
var getStagedDefaultContactPropertyValueForSelectedProperty = (0, _reselect.createSelector)([getStagedDefaultContactPropertyValues, getSelectedProperty, _routeSelectors.getAllDomainsOrDomainNameFromRoute], function (propertyValues, selectedProperty, allDomainsOrDomainName) {
  if (allDomainsOrDomainName === _UrlPathParams.ALL_DOMAINS) {
    return propertyValues.getIn([_UrlPathParams.ALL_DOMAINS, selectedProperty]) || '';
  }

  return propertyValues.getIn(['byDomain', allDomainsOrDomainName, selectedProperty]) || '';
});
exports.getStagedDefaultContactPropertyValueForSelectedProperty = getStagedDefaultContactPropertyValueForSelectedProperty;
var getStagedDefaultCompanyPropertyValueForSelectedProperty = (0, _reselect.createSelector)([getStagedDefaultCompanyPropertyValues, getSelectedProperty, _routeSelectors.getAllDomainsOrDomainNameFromRoute], function (propertyValues, selectedProperty, allDomainsOrDomainName) {
  if (allDomainsOrDomainName === _UrlPathParams.ALL_DOMAINS) {
    return propertyValues.getIn([_UrlPathParams.ALL_DOMAINS, selectedProperty]) || '';
  }

  return propertyValues.getIn(['byDomain', allDomainsOrDomainName, selectedProperty]) || '';
});
exports.getStagedDefaultCompanyPropertyValueForSelectedProperty = getStagedDefaultCompanyPropertyValueForSelectedProperty;
var getStagedDefaultOwnerPropertyValueForSelectedProperty = (0, _reselect.createSelector)([getStagedDefaultOwnerPropertyValues, getSelectedProperty, _routeSelectors.getAllDomainsOrDomainNameFromRoute], function (propertyValues, selectedProperty, allDomainsOrDomainName) {
  if (allDomainsOrDomainName === _UrlPathParams.ALL_DOMAINS) {
    return propertyValues.getIn([_UrlPathParams.ALL_DOMAINS, selectedProperty]) || '';
  }

  return propertyValues.getIn(['byDomain', allDomainsOrDomainName, selectedProperty]) || '';
});
exports.getStagedDefaultOwnerPropertyValueForSelectedProperty = getStagedDefaultOwnerPropertyValueForSelectedProperty;